/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material/styles';

import { CIColors } from 'shared';

type MuiBreadcrumbsComponent = {
  defaultProps?: ComponentsProps['MuiBreadcrumbs'];
  styleOverrides?: ComponentsOverrides['MuiBreadcrumbs'];
  variants?: ComponentsVariants['MuiBreadcrumbs'];
};

export const BreadcrumbsComponent: MuiBreadcrumbsComponent = {
  styleOverrides: {
    root: {
      lineHeight: '14px',
    },
    ol: {
      alignItems: 'baseline',
    },
    li: {
      fontSize: '14px',
      lineHeight: '14px',
      letterSpacing: '-0.11px',
      fontWeight: 400,
      '&> *': {
        fontSize: '14px',
        lineHeight: '14px',
      },
      '&> a': {
        color: CIColors.Text,
        textDecoration: 'none',
      },
      '&> p': {
        color: CIColors.Primary,
        fontWeight: 600,
      },
    },
    separator: {
      marginLeft: '4px',
      marginRight: '4px',
      color: CIColors.Text,
      fontSize: '14px',
    },
  },
};
